import Index from "../index";
import request from "@/common/request";
import {
  IVideo,
  ISpecialDetailResponse,
  ISpecialListResponse
} from "./types.d";
import { IResponse } from "../types";
import { IGetInfoThemeList } from "../wanzhou/types";
class IndexRequest extends Index {
  /**
   * 获取视频详情
   * @param id
   */
  async getVideo(appId: string, id: string): Promise<IVideo | any> {
    let res;
    try {
      const res1 = await request.get(
        process.env.VUE_APP_BASE_JSON +
          `/app/news/getVideoDetail/${appId}/${id}.json`
      );
      res = {
        data: res1,
        code: 0
      };
    } catch (error) {
      res = await request.post("/video/getVideoDetail.html", {
        appId: appId,
        id: id
      });
    }
    return res;
  }
  /**
   * 江津专题详情
   * @param params
   * @returns
   */
  getTopicManage(params: {
    appId: string;
    infoClassifyId: string;
  }): Promise<ISpecialDetailResponse> {
    return request.post("/getTopicManage.html", {
      appId: params.appId,
      infoClassifyId: params.infoClassifyId
    });
  }

  /**
   * 江津专题列表
   * @param params
   * @returns
   */
  getTopicClassificationList(params: {
    appId: string;
    infoClassifyId: string;
  }): Promise<ISpecialListResponse> {
    return request.post("/getTopicClassificationList.html", {
      appId: params.appId,
      infoClassifyId: params.infoClassifyId
    });
  }

  /**
   * 分类列表
   * @param lastId 最后一个id
   * @param infoThemeId 分类id
   * @param sortNoValue 排序号
   * @param onlineTimeValue 上线时间
   */
  infoThemeList(
    infoClassifyId: string,
    infoThemeId: string,
    // limit: number,
    // page: number,
    appId: string,
    lastId?: string,
    sortNoValue?: string,
    onlineTimeValue?: string
  ): Promise<any> {
    return request.post(
      process.env.VUE_APP_BASEGATE_API + "/info/getSpecialSubList",
      {
        infoClassifyId,
        themeId: infoThemeId,
        appId: appId,
        lastId,
        lastSortNo: sortNoValue,
        lastOnlineTime: onlineTimeValue
      }
    );
  }
  /**
   * 分类列表
   * @param lastId 最后一个id
   * @param infoThemeId 分类id
   * @param sortNoValue 排序号
   * @param onlineTimeValue 上线时间
   */
  getTopicChildlList(
    infoClassifyId: string,
    infoThemeId: string,
    // limit: number,
    // page: number,
    appId: string,
    lastId?: string,
    sortNoValue?: string,
    onlineTimeValue?: string
  ): Promise<any> {
    return request.post("/getTopicChildlList.html", {
      infoClassifyId,
      themeId: infoThemeId,
      appId: appId,
      lastId,
      lastSortNo: sortNoValue,
      lastOnlineTime: onlineTimeValue
    });
  }
}

export default IndexRequest;
